import React, { Component } from 'react'
import Error from '../../_global/Error'

export default class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch() {
    this.setState({ hasError: true })
  }

  render() {
    const { hasError } = this.state

    if (hasError) {
      return <Error />
    }

    return this.props.children
  }
}
